export default __webpack_public_path__ + "static/media/laravel.d0cb2f2a.svg";